import "../components/Breadcrumbs/index.js";
import "../components/Button/index.js";
import "react/jsx-runtime";
import "classnames";
import "react";
import "reactjs-popup";
import "../components/ThemeContext/index.js";
import "../modal-l0sNRNKZ.js";
import "react-i18next";
import "../fields/Input/index.js";
import "../components/Tooltip/index.js";
import "../fields/FieldContainer/index.js";
import "../fields/Checkbox/index.js";
import "../fields/ContentEditable/index.js";
import "../fields/DateInput/index.js";
import "date-fns";
import "../fields/Select/index.js";
import "react-dropzone";
import "react-dom";
import "../fields/InputTooltip/index.js";
import "../fields/PhoneInput/index.js";
import "../fields/SocialSelect/index.js";
import "../fields/Switcher/index.js";
import "../fields/Textarea/index.js";
import "../fields/Wysiwyg/index.js";
import "../fillDocument/FillForm/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import { sideVariableHelpers as h } from "../helpers/templateSidesFunctions.js";
const I = (n, v, b, f, F) => {
  if (!n)
    return null;
  const o = {}, l = F && Object.values(F).flatMap(({ groups: i }) => i);
  return n.variables.length && n.variables.forEach(({ id: i, sideId: r, sideName: e }) => {
    const a = v.find((t) => t.id === r);
    if (!(a && a.tattrFolders.find(({ tattrs: m }) => !!m.find((c) => c.id === i)))) {
      if (o[r] || (o[r] = { id: r, name: e, tattrFolders: [], tables: [], carticles: [] }), b && b[i]) {
        const t = l == null ? void 0 : l.find(({ items: m }) => m.includes(i));
        o[r].tattrFolders = h.addVariableToFolder(
          o[r].tattrFolders,
          b[i],
          { id: t == null ? void 0 : t.groupId, name: t == null ? void 0 : t.name }
        );
      } else if (f && f[i]) {
        const t = l == null ? void 0 : l.find(({ groupId: m }) => m === f[i].folderid);
        o[r].tattrFolders = h.addVariableToFolder(
          o[r].tattrFolders,
          f[i],
          { id: t == null ? void 0 : t.groupId, name: t == null ? void 0 : t.name }
        );
      }
    }
  }), n.tables.length && n.tables.forEach(({ id: i, name: r, sideId: e, sideName: a, resized: t, columns: m, total: c, showTotalRow: s }) => {
    o[e] || (o[e] = { id: e, name: a, tattrFolders: [], tables: [], carticles: [] }), o[e].tables.find((p) => p.id === i) || o[e].tables.push({
      id: i,
      name: r,
      resized: t,
      columns: m,
      total: c,
      showTotalRow: s
    });
  }), n.variations.length && n.variations.forEach(({ id: i, sideId: r, sideName: e, title: a, multiple: t, parents: m, variants: c }) => {
    const s = v.find((p) => p.id === r);
    if (s && s.carticles.find((P) => P.id === i))
      return;
    o[r] || (o[r] = { id: r, name: e, tattrFolders: [], tables: [], carticles: [] }), o[r].tables.find((p) => p.id === i) || o[r].carticles.push({
      id: i,
      title: a,
      multiple: t,
      parents: m,
      variants: c
    });
  }), Object.values(o);
};
export {
  I as default
};
